import { CodeBook, DocumentData } from "@king-ict/eupisi-ui/models";

export interface TeacherLanguage {
    id: number;
    language?: CodeBook;
    dateFrom: Date;
    dateTo?: Date;
    certificationDocument?: DocumentData;
}

export const createTeacherLanguageInitial = (): TeacherLanguage => {  
    return {
      id: 0,
      dateFrom: new Date(),      
    };
  }